<div class="loading" [@esvanecerDesvanecer]="'out'">
    <img [src]="logoSecondary$ | async" />
</div>
<router-outlet></router-outlet>
<div #achievementDialog></div>
